export const deTranslations = {
    navbar: {
        restaurant_location: "Wegbeschreibung zum Restaurant",
        make_reservations: "Reservierung machen",
        search_product: "Produkt suchen",
        call_waiter: "Kellner rufen",
        change_language: "Sprache ändern",
        feedback: "Bewerten Sie uns",
        about_tabl: "Über TABL",
    },

    pages: {
        products: {
            choose: "Auswählen",
            choose_ingredients: "Zutaten wählen",
            choose_variant: "Bitte wählen",
            alergens: "Allergene",
            minimum_durability: "Mindesthaltbarkeit: bis zu {value} Stunden nach der Zubereitung",
            out_of_stock: "Nicht verfügbar",
            variant_not_choosed: "Sie haben keine Variante gewählt!",
            min_count_addable_ingredients_reached: "Du musst mindestens {value} Extras wählen!",
            max_count_addable_ingredients_reached: "Du kannst nicht mehr als {value} Extras wählen!",
            additional_options: "Zusätzliche Optionen",
            addable_options: "Extras",
            removable_options: "Entfernen",
            comment: "Kommentar zum Produkt",
            related_products: "Weitere Empfehlungen",
            add: "Hinzufügen",
            add_to_cart: "In den Warenkorb", // in context 'add to cart'
            choose_size: "Wählen",
            save_for_order: "Für Bestellung speichern",
            order_disabled: "Dieses Produkt kann momentan nicht bestellt werden!",
            book: "Reservieren"
        },
        change_language: {
            title: "Bitte wählen Sie eine Sprache",
        },
        call_waiter: {
            clean_table: "Bitte Tisch reinigen",
            new_cutlery: "Bitte neue Bestecke",
            more_napkins: "Bitte mehr Servietten",
            change_ashtray: "Bitte Aschenbecher wechseln",
            bring_ice: "Bitte Eis bringen",
            other: "Sonstiges",
        },
        feedback: {
            title: "Nimm dir eine Minute für eine Bewertung",
            customer_reviews: "Kundenbewertungen",
            no_reviews_yet: "Sei einer der Ersten, der diesen Service bewertet.",
            choose_waiter: "Wählen Sie, wer Sie bedient hat:",
            what_went_wrong: "Es tut uns leid! Was war nicht in Ordnung?",
            already_rated: "Sie haben vor Kurzem bereits eine Bewertung abgegeben. Vielen Dank!",
            google_review_title: "Wir freuen uns, dass alles in Ordnung war!",
            google_review_button: "Bewerten Sie uns bei Google"
        },
        about_tabl: {
            title: "Dieser Service wird Ihnen ermöglicht durch ",
            sub_title: "Für weitere Informationen zur TabL-Plattform, kontaktieren Sie uns bitte.",
            about_link: "https://tabl.bg/"
        },
        cart_delivery: {
            minimal_order_price: "Der Mindestbestellwert für die Lieferung ist {value}",
            price_according_to_region: "Preis nach Region",
            payment_type_room: "Zahlungsart bei Servieren",
            payment_type_pickup: "Zahlungsart bei Abholung",
            payment_type_delivery: "Zahlungsart bei Lieferung",
            cutlery_needed: "Möchten Sie Besteck?",
            how_many_cutlery_needed: "Wie viele Bestecke möchten Sie?",
            cutlery_needed_yes: "Ja, bitte",
            cutlery_needed_no: "Nein, danke",
            region: "Region",
            call_waiter_to_order: "Bitte rufen Sie den Kellner, um zu bestellen",
            you_can_order_between: "Sie können bestellen von {from} bis {to} und von {from_two} bis {to_two}",
            restaurant_closed_label: "Wir nehmen zurzeit keine Bestellungen an. Danke für Ihr Verständnis!",
            restaurant_closed_label_day: "Wir nehmen zurzeit keine Bestellungen an, bitte versuchen Sie es erneut am {day}: {value}",
            restaurant_closed_label_tommorow: "Wir nehmen zurzeit keine Bestellungen an, bitte versuchen Sie es morgen um {value} erneut",
            restaurant_closed_label_today: "Wir nehmen zurzeit keine Bestellungen an, bitte versuchen Sie es später um {value} erneut",
            closed_today_exception: "Wir nehmen zurzeit keine Bestellungen an, bitte versuchen Sie es erneut",
            closed_today: "Heute geschlossen",
            next_working_day: "Nächster Arbeitstag",
            tomorrow: "morgen um",
            on_day: "am",
            delivery_price: "Liefergebühr",
            delivery_price_is_not_included: "+ Liefergebühr",
            cart: "Warenkorb",
            no_cart_items: "Keine Produkte im Warenkorb",
            orders: "Bestellt",
            order: "Bestellung",
            min_delivery_price_text: 'Für Bestellungen über {value} ist die Lieferung kostenlos',
            no_order_items: "Zurzeit keine aktiven Bestellungen",
            order_placed_success: "Ihre Bestellung wurde erfolgreich aufgegeben! Den Status können Sie unten verfolgen.",
            total: "Preis",
            total_bill: "Gesamt",

            status_ordered: 'Angenommen',
            status_cooked_spot: 'Zubereitet',
            status_cooked_delivery: 'Zubereitet',
            status_cooked_preorder: 'Wartet auf Kunde',
            status_served_spot: 'Serviert',
            status_on_the_way_delivery: 'Unterwegs',
            status_paid: 'Abgeschlossen',
            rejected: 'Abgelehnt',

            pay_in_cash: "Bar bezahlen",
            pay_with_card: "Mit Karte bezahlen",
            make_order: "Bestellen",
            make_order_simple: "Bestellen",
            want_the_bill: "Rechnung anfordern",
            finish_bill: "Rechnung abschließen",
            kiosk_idle_title: "Sind Sie noch da?",
            kiosk_idle_text: "Zurück zum Startbildschirm in {seconds} Sek.",
            kiosk_idle_continue: "Ja, weiter",
            make_delivery_order: "Lieferung bestellen",
            choose_order_type: "Bestellart wählen",
            choose_payment_type: "Zahlungsart wählen",
            payment_cash: "Bar",
            payment_card: "Karte",
            payment_epay: "Online",
            payment_online: "Online",
            payment_cash_delivery: "Bar",
            payment_card_delivery: "Karte bei Lieferung",
            payment_epay_delivery: "Online",
            payment_on_room_bill: "Aufs Zimmer",
            payment_online_delivery: "Online",
            "payment_online.bizum": "Bizum",
            "payment_online.bizum_delivery": "Bizum",
            delivery_price_included_in_total_price: "Mit Liefergebühr {delivery_price_num} für Bestellungen bis {min_price_free_delivery_num} enthalten",
            order_type_restaurant: "Im Restaurant",
            scan_barcode: "QR-Code scannen",
            order_type_delivery: "Lieferung nach Hause",
            order_type_preorder: "Abholung",
            order_type_room: "Bestellung aus Zimmer",
            order_type_served_on_spot: "Vor Ort verzehren",
            order_from_room: "Zimmerbestellung",
            first_and_last_name: "Vor- und Nachname",
            phone: "Telefonnummer",
            order_address: "Adresse: Str. Nr. Et. Whg. Stadt",
            delivery_time: "Datum und Uhrzeit der Lieferung",
            delivery_address: "Lieferadresse",
            room_number: "Zimmernummer",
            table: "Tisch",
            room: "Zimmer",
            email: "E-Mail",
            remember_me: "Angemeldet bleiben",
            promo_code: "Promo-Code",
            promo_code_placeholder: "Promo-Code...",
            apply: "Anwenden",
            cancel: "Abbrechen",
            bill_already_wanted: "/Ihre Rechnung wurde bereits angefordert/",
            clear: "Leeren",
            close: "Schließen",
            save: "Speichern",
            save_and_add: "Speichern und hinzufügen",
            fast_order: "Schnellbestellung", // NOT TRANSLATED
            in_the_region_delivery: "Ich bin im Gebiet {region}",
            no_saved_addresses_with_that_name: 'Sie haben keine gespeicherten Adressen mit diesem Namen. Bitte fügen Sie eine unter „Neue Adresse“ hinzu.',
            choose_pickup_place: "Abholrestaurant wählen",
            choose_pickup_place_label: "Restaurant wählen",
            served_on_spot: "Vor Ort serviert",
            choose_address: "Adresse wählen",
            add_new_address: "Neue Adresse",
            choose_delivery_address: "Lieferadresse wählen",
            type_address: 'Geben Sie die Adresse ein',
            recent_addresses: 'Letzte Adressen:',
            choose_on_map: 'Auf der Karte wählen',
            adjust_on_map: 'Auf der Karte anpassen',
            choose_location: 'Standort wählen',
            change_location: 'Standort ändern',
            use_current_location: 'Aktuellen Standort verwenden',
            coordinates: 'Koordinaten',
            not_delivering_to_address: 'Wir liefern nicht an diese Adresse',
            address_not_found: 'Das System konnte diese Adresse nicht finden. Bitte versuchen Sie es erneut',
            address_search_error: 'Bei der Adresssuche ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut',
            address_not_recognized: 'Wir finden diese Adresse nicht. Bitte versuchen Sie es erneut',
            floor_and_appartment: "Et./Whg.",
            floor_short: "Et.",
            appartment_short: "Whg.",
            street_number_short: "Nr./Bl.",
            street_number_only_short: "Nr.",
            building_number_short: "Bl.",
            bell_short: 'Kl.',
            entrance_short: 'Eing.'
        },
        search: {
            searchProduct: "Produkt suchen",
            noSearchResults: "Keine Produkte gefunden",
            noSearchDescription: "Bitte ändern Sie die Suchkriterien, um ein passendes Produkt zu finden!",
        },
        choose_place: {
            title: "Bitte wählen Sie einen Standort"
        },
        promotions: {
            title: "Aktion"
        },
        profile: {
            title: "Mein Profil",
            fullname: "Vor- und Nachname",
            first_name: "Vorname",
            last_name: "Nachname",
            email: "E-Mail",
            phone: "Telefon",
            address: "Adresse",
            change_password: "Passwort ändern",
            password: "Passwort",
            new_password: "Neues Passwort",
            tabl_points: "TABL-Punkte",
            tabl_points_info: "Sammle TABL-Punkte mit jeder Bestellung und freue dich auf tolle Überraschungen ;)",
            my_profile: "Mein Profil",
            profile: "Profil",
            logout: "Abmelden",
            orders: "Meine Bestellungen",
            set_waiter_table: "Tisch für Bestellung festlegen",
            change_waiter_table: "Tisch für Bestellung ändern",
            edit_profile_success: "Daten erfolgreich geändert :)",
            edit_profile_error: "Fehler. Bitte versuche es erneut"
        },
        my_orders: {
            title: "Meine Bestellungen",
            order_date: "Bestelldatum",
            products: "Produkte",
            type: "Typ",
            amount: "Betrag",
            payment: "Zahlung",
            status: "Status",
            address: "Adresse",
            personal_data: "Daten"
        },
        booking: {
            book: "Reservieren",
            choose_time: "Datum & Uhrzeit wählen",
            minutes: "Min.",
            success_booking: "Reservierung erfolgreich. Eine Bestätigungs-E-Mail wurde gesendet. Registriere dich, um deine Reservierungen zu verfolgen ;)"
        }
    },
    orders: {
        statuses: {
            ordered: "Bestellt",
            cooked_spot: 'Zubereitet',
            served_spot: 'Serviert',
            cooked_delivery: 'Zubereitet',
            on_the_way_delivery: 'Unterwegs',
            cooked_preorder: 'Zubereitet',
            cooked_room: "Zubereitet",
            paid: "Bezahlt",
            rejected: "Abgelehnt"
        },
        paid_online: "Online bezahlt",
    },
    common: {
        tip: 'Trinkgeld',
        custom_amount: 'Anderer Betrag',
        no_tip: 'Kein Trinkgeld',
        discount_online_payments: 'Online-Zahlungsrabatt',
        hi: "Hallo",
        home: "Startseite",
        free_del: "Kostenlos", // Not "kostenloser"
        amount: "Betrag",
        subtotal: "Zwischensumme",
        final_price: "Endpreis",
        no_internet: "Keine Internetverbindung.",
        count: 'Stk.',
        box: "Box",
        change_place: 'Standort wechseln',
        current_place: 'Aktueller Standort',
        like_us: "Gefällt dir unser Service?",
        follow_us: "Folge uns",
        youtube: "YouTube",
        tipadvisor: "Tripadvisor",
        about: 'Über',
        about_us: 'Über uns',
        discount: 'Rabatt',
        personal_discount: 'Persönlicher Rabatt',
        discount_promocode: 'Rabattcode',
        delivery: 'Lieferung',
        book: 'Reservieren',
        language: 'Sprache',
        navigate_me: "Bring mich hin",
        navigation: 'Navigation',
        search: 'Suchen',
        call_us: 'Anrufen',
        options: 'Optionen',
        open: 'Öffnen',
        product: "Produkt",
        products: "Produkte",
        user: "Benutzer",
        choose: 'Bitte wählen',
        comment: "Kommentar",
        contacts: "Kontakt",
        working_hours: "Öffnungszeiten",
        payment_methods: "Zahlungsarten",
        gallery: "Galerie",
        change_table: "Tisch wechseln",
        clear_cart: "Leeren",
        modify_ingredients: "Zutaten ändern",
        about_page_facilities: "Ausstattung",
        about_page_household: "Haushalt",
        about_page_technical_support: "Technischer Support",
        boxes_prices: "Box",
        refund_policy: "Rückerstattungsrichtlinie",
        date: {
            today: "Heute",
            tommorow: "Morgen",
            day: {
                1: 'Montag',
                2: 'Dienstag',
                3: 'Mittwoch',
                4: 'Donnerstag',
                5: 'Freitag',
                6: 'Samstag',
                7: 'Sonntag',
            }
        },

        action: {
            send: "Senden",
            skip: "Überspringen",
            back: "Zurück",
        },

        label: {
            describe_here: "Hier beschreiben",
        },

        price_with_discount: "Preis mit Rabatt",
        subscribe_for_lunch_menu: "Mittagsangebote von TABL erhalten",
        cart: 'Warenkorb',
        profile: "Profil",
        login_or_register: "Anmelden / Registrieren",
        close: "Schließen",
        terms_for_use: "Nutzungsbedingungen",
        privacy_policy: "Datenschutzrichtlinie",
        i_read_and_agree_with: "Ich habe gelesen und stimme zu ",
        i_agree_with: "Ich stimme zu",
        currency_bgn: " лв.",
        add_btn: "Hinzufügen",
        order_comment: "Kommentar zur Bestellung",
        order_modal_agree_with: "Mit Aufgabe der Bestellung stimmen Sie unseren ",
        and: ' und',
        cutleries: "Besteck",
        save: "Speichern",
        to_the_menu: "Zum Menü"
    },

    messages: {
        notifications: {
            waiter_notified_successfully: 'Der Kellner wurde erfolgreich benachrichtigt',
            order_sent_success: "Ihre Bestellung wurde erfolgreich aufgegeben.",
            feedback_thanks: "Vielen Dank für Ihr Feedback!",
            bill_wanted_success: 'Ihre Rechnung wurde erfolgreich angefordert.',
            user_need_success: 'Ihre Anfrage wurde erhalten und wird bearbeitet',
            create_order_first: "Bitte machen Sie zuerst eine Bestellung",
            bill_already_wanted: "Ihre Rechnung wurde bereits angefordert",
            reset_password_success: "Wenn ein Konto mit dieser E-Mail existiert, erhalten Sie Anweisungen zum Zurücksetzen des Passworts :)",
        },
        errors: {
            invalid_privacy_policy_and_terms: "Bitte stimmen Sie unseren Datenschutzrichtlinien und AGB zu",
            invalid_privacy_policy: "Bitte stimmen Sie unseren Datenschutzrichtlinien zu",
            invalid_terms: "Bitte stimmen Sie unseren AGB zu",
            invalid_email: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
            invalid_password: 'Bitte geben Sie ein gültiges Passwort ein',
            invalid_paddword_min: 'Bitte geben Sie ein Passwort mit mindestens {value} Zeichen ein',
            invalid_name: 'Bitte geben Sie einen gültigen Namen ein /3 bis 40 Zeichen/',
            invalid_phone: 'Bitte geben Sie eine gültige Telefonnummer ein',
            invalid_phone_min: 'Bitte geben Sie eine Telefonnummer mit mindestens {value} Zeichen ein',
            invalid_field: 'Bitte geben Sie einen Wert in das Feld ein',
            invalid_address: 'Bitte geben Sie eine gültige Adresse ein',
            invalid_regionId: 'Bitte wählen Sie eine Region',
            invalid_orderDate: 'Bitte geben Sie ein Lieferdatum ein',
            invalid_orderTime: 'Bitte geben Sie eine Lieferzeit ein',
            invalid_room_number: 'Bitte geben Sie eine Zimmernummer ein',
            invalid_payment_method: 'Bitte wählen Sie eine Zahlungsart',
            invalid_cutlery_selected: "Bitte wählen Sie, ob Sie Besteck wünschen",
            invalid_additional_order_type: "Bitte wählen Sie eine Bestellart",
            invalid_text_comment: "Bitte geben Sie einen gültigen Kommentar (max. 500 Zeichen) ein",
            invalid_fields: "Bitte füllen Sie alle Felder korrekt aus",
            order_sent_fail: "Bitte QR-Code erneut scannen!",
            bill_wanted_fail: "Ups, Rechnung kann nicht angefordert werden!",
            user_need_fail: 'Ups, beim Senden der Anfrage ist ein Fehler aufgetreten',
            "Too many requests, please try again later.": "Sie haben das Anfrage-Limit erreicht. Bitte versuchen Sie es später erneut.",
            "Invalid phone": "Ungültige Telefonnummer",
            "Invalid name": "Ungültiger Name",
            error: "Fehler",
            invalid_pickup_place: 'Bitte wählen Sie einen Abholort',

            invalid_street_number: "Hausnummer oder Blocknummer eingeben",
            invalid_street_number_length: "Nummer ist zu lang",
            invalid_street_number_required: "Hausnummer fehlt",
            invalid_building_number: "Blocknummer fehlt",
            invalid_building_number_length: "Blocknummer ist zu lang",

            invalid_floor_number: "Etage fehlt",
            invalid_floor_number_length: "Nummer ist zu lang",

            invalid_ap_number: "Wohnungsnummer fehlt",
            invalid_ap_number_length: "Nummer ist zu lang",

            invalid_bell_number: "Klingelnummer fehlt",
            invalid_bell_number_length: "Nummer ist zu lang",
            invalid_entrance_number: "Eingangsnummer fehlt",
            invalid_entrance_number_length: "Nummer ist zu lang",
            invalid_required_checkbox_in_order_modal: "Sie müssen zustimmen",
            invalid_required_checkbox_in_order_modal_2: "Sie müssen zustimmen",

            please_try_again: "Bitte versuchen Sie es erneut.",
            too_mony_orders_for_session_in_x_seconds: "Sie versuchen, dieselbe Bestellung mehrfach abzusenden. Bitte versuchen Sie es in einigen Sekunden erneut.",
            invalid_delivery_shape: "Bitte überprüfen Sie die Lieferadresse oder geben Sie sie erneut ein",
            invalid_region_for_place: "Bitte überprüfen Sie die Lieferregion oder wählen Sie sie erneut aus",
            orders_not_allowed: "Wir nehmen momentan keine Bestellungen an. Bitte versuchen Sie es später erneut.",
            invalid_products_for_place: "Sie versuchen, Produkte von einem anderen Standort zu bestellen. Die Seite wird neu geladen. Bitte bestellen Sie erneut. Entschuldigen Sie die Unannehmlichkeiten :)",
            place_not_active: "Das Menü wurde aktualisiert. Die Seite wird neu geladen. Bitte bestellen Sie erneut. Entschuldigen Sie die Unannehmlichkeiten :)",
            error_sending_order: "Fehler beim Senden der Bestellung!",
            please_scan_qr_code_to_order: "Bitte scannen Sie den QR-Code, um zu bestellen."
        }
    },

    modals: {
        upselling_products: {
            title: "Wie wäre es mit"
        },
        language_modal: {
            back_to_default_lang: "Zur Standardsprache",
            translations_may_not_be_accurate: "Übersetzungen können ungenau sein"
        },
        initial_html_banner: {
            title: "Willkommen",
            to_the_menu: "Zum Menü"
        },
        add_to_home_screen: {
            title: "Menü zum Startbildschirm hinzufügen",
            body: "Öffne es wie eine App — im Vollbild, sofort und ohne Suchen.",
            ios_title: "Menü zum Startbildschirm hinzufügen",
            ios_body: "Tippe unten auf „Teilen“ und wähle „Zum Home-Bildschirm“.",
            ios_chrome_body: "Tippe in der Adressleiste auf „Teilen“ und wähle „Zum Home-Bildschirm“.",
            ios_other_body: "Öffne das Browsermenü, tippe auf „Teilen“ und wähle „Zum Home-Bildschirm“.",
            install: "Hinzufügen",
            close: "Schließen"
        }
    },

    promocode: {
        others_discounts_are_not_applied: "Bei Nutzung dieses Promo-Codes werden alle anderen Rabatte (falls vorhanden) NICHT angewendet"
    },

    payments: {
        choose_payment_method: "Zahlungsart wählen",
        processing: "Zahlung wird verarbeitet",
        payment_failed: "Zahlung fehlgeschlagen. Bitte versuche es erneut.",
        payment_success: "Bestellung erfolgreich aufgegeben"
    },
    login: {
        log_in_your_profile: "Melde dich in deinem Profil an",
        save_your_data: "und speichere deine Daten",
        login_btn: "Anmelden",
        register_if_no_profile: "Noch kein Profil? Registriere dich",
        forgot_password: "Passwort vergessen?",
        login_success: "Erfolgreich eingeloggt",
        logout_success: "Bis bald :(",
        login_fail: "Ungültige Anmeldedaten"
    },
    register: {
        register: "Registrieren",
        collect_tabl_points: "und TABL-Punkte sammeln",
        register_btn: "Registrieren",
        already_have_account: "Schon ein Profil? Anmelden",
        successful_registration: "Erfolgreich registriert. Bitte melde dich an :)"
    },
    forgot_password: {
        forgot_password: "Passwort vergessen",
    },
    accumulated_order_amount: {
        use: "Verwenden",
        remove: "Entfernen",
        register_for_discount: "Registriere dich und spare bei jeder Bestellung",
        you_have_accumulated: "Du hast angesammelt",
        no_accumulated_money_text: "Bestelle und spare bei deiner nächsten Bestellung",
        register_and_accumulate: "Registriere dich und gewinne",
        for_you_next_order: "für deine nächste Bestellung",
        complete_your_order_and_accumulate: "Schließe deine Bestellung ab und sammle",
        profile_text: "Angesparte Beträge aus Bestellungen",
        profile_description: "Mit jeder Bestellung wird ein % des Betrags deinem Profil gutgeschrieben. Bei deinem nächsten Kauf kannst du diesen nutzen :)"
    }
}
